var O = /* @__PURE__ */ ((E) => (E[E.ORDER = 1] = "ORDER", E[E.FACEBOOK_EVENT = 2] = "FACEBOOK_EVENT", E))(O || {});
export {
  O as PaymentActionType
};
//# sourceMappingURL=payment.action.type.js.map
